import { post } from "@/request/http";

// 获取权限列表
// http://showdoc.mools.net/web/#/13?page_id=126
export const apiGetAuthList = p => post("/auth/getAuthList", p);

// 添加/修改权限信息
// http://showdoc.mools.net/web/#/13?page_id=123
export const updateAuthInfo = p => post("/auth/updateAuthInfo", p);

// 删除权限信息
// http://showdoc.mools.net/web/#/13?page_id=125
export const deleteAuth = p => post("/auth/deleteAuth", p);
